<cm-routed-dialog [dialogSize]="DialogSize.Small">
    <ng-container cm-overlay-content>
        <cm-details-dialog-layout [loadError]="$loadError()" [isLoaded]="!!$item()">
            <ng-container cm-title>
                <cm-title-section
                    [title]="$title()"
                    [isLoaded]="$item() !== undefined"
                    [canEdit]="$can().update.organization()"
                    (onChanged)="$updateItemSubject().next({name: $event})"
                    (onClosed)="closeModal()"
                ></cm-title-section>
            </ng-container>

            <ng-container cm-buttons>
                @if ($item(); as organization) {
                    <button class="cm-simple-window-header-button cm-item-menu" [matMenuTriggerFor]="menuOptions">
                        <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <mat-menu #menuOptions="matMenu">
                        <button mat-menu-item (click)="activateOrganization()">Switch to this organization</button>
                        <button mat-menu-item (click)="removeGalleryImage()" [disabled]="!$canRemoveGalleryImage()">Remove gallery image</button>
                    </mat-menu>
                }
            </ng-container>
            <ng-container cm-main>
                <cm-gallery-image [item]="$item()"></cm-gallery-image>
                <cm-attachments
                    [item]="$item()"
                    [organizationId]="$item()?.id ?? null"
                    class="cm-files"
                    [showSetGalleryImageOption]="false"
                    [showSetCustomerLogoOption]="true"
                    [assignmentTypes]="assignmentTypes"
                ></cm-attachments>
            </ng-container>
            <ng-container cm-sidebar>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>Name</mat-label>
                    <input name="organizationName" matInput [ngModel]="$item()?.name" (ngModelChange)="updateItem({name: $event})" />
                </mat-form-field>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>URL</mat-label>
                    <input name="url" matInput id="url" [ngModel]="$item()?.url" (ngModelChange)="updateItem({url: $event})" />
                </mat-form-field>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>Active</mat-label>
                    <mat-select [value]="$item()?.isActive" (valueChange)="updateItem({isActive: $event})">
                        <mat-option [value]="true">Yes</mat-option>
                        <mat-option [value]="false">No</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>Visible in filters</mat-label>
                    <mat-select [value]="$item()?.visibleInFilters" (valueChange)="updateItem({visibleInFilters: $event})">
                        <mat-option [value]="true">Yes</mat-option>
                        <mat-option [value]="false">No</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>Sales email</mat-label>
                    <input name="salesEmail" matInput id="salesEmail" [ngModel]="$item()?.salesEmail" (ngModelChange)="updateItem({salesEmail: $event})" />
                </mat-form-field>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>Default scanner URL</mat-label>
                    <input
                        name="defaultScannerUrl"
                        matInput
                        id="defaultScannerUrl"
                        [ngModel]="$item()?.defaultScannerUrl"
                        (ngModelChange)="updateItem({defaultScannerUrl: $event})"
                    />
                </mat-form-field>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>Material Explorer Template ID</mat-label>
                    <input
                        name="matExplorerTemplateId"
                        matInput
                        id="matExplorerTemplateId"
                        [ngModel]="$item()?.matExplorerTemplate?.legacyId"
                        (ngModelChange)="updateItem({matExplorerTemplateId: parseLegacyIdFromString($event)})"
                        type="number"
                    />
                </mat-form-field>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>Material Explorer Material ID</mat-label>
                    <input
                        name="matExplorerMaterialId"
                        matInput
                        id="matExplorerMaterialId"
                        [ngModel]="$item()?.matExplorerMaterial?.legacyId"
                        (ngModelChange)="updateItem({matExplorerMaterialId: parseLegacyIdFromString($event)})"
                        type="number"
                    />
                </mat-form-field>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>Material Asset Template ID</mat-label>
                    <input
                        name="materialAssetsTemplateId"
                        matInput
                        id="materialAssetsTemplateId"
                        [ngModel]="$item()?.materialAssetsTemplate?.legacyId"
                        (ngModelChange)="updateItem({materialAssetsTemplateId: parseLegacyIdFromString($event)})"
                        type="number"
                        [placeholder]="$fallbackTemplateId().toString()"
                    />
                </mat-form-field>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>Node Editor Template ID</mat-label>
                    <input
                        name="nodeEditorTemplateId"
                        matInput
                        id="nodeEditorTemplateId"
                        [ngModel]="$item()?.nodeEditorTemplate?.legacyId"
                        (ngModelChange)="updateItem({nodeEditorTemplateId: parseLegacyIdFromString($event)})"
                        type="number"
                    />
                </mat-form-field>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>Organization type</mat-label>
                    <mat-select [value]="$item()?.type" (valueChange)="updateItem({type: $event})">
                        <mat-option [value]="null">None</mat-option>
                        <mat-option [value]="OrganizationType.EnterpriseCloud">Enterprise cloud</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>Account type</mat-label>
                    <input name="accountType" [disabled]="true" matInput [ngModel]="$item()?.selfServiceSignup ? 'Self service' : 'Manual creation'" />
                </mat-form-field>
                @if ($can().update.organization($item(), "defaultJobsPriority")) {
                    <mat-form-field [cmIsLoading]="!$item()">
                        <mat-label>Default jobs priority</mat-label>
                        <input
                            name="defaultJobsPriority"
                            matInput
                            type="number"
                            [ngModel]="$item()?.defaultJobsPriority"
                            (ngModelChange)="updateItem({defaultJobsPriority: parsePriority($event)})"
                            placeholder="0"
                        />
                    </mat-form-field>
                }
                <h4>PDF Style Settings</h4>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>Margin Top (pt)</mat-label>
                    <input
                        name="marginTop"
                        matInput
                        type="number"
                        #marginTop="ngModel"
                        [ngModel]="$item()?.pdfStyleSettings?.marginTop"
                        (blur)="updatePdfStyleSettings('marginTop', marginTop.value)"
                        placeholder="40"
                    />
                </mat-form-field>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>Margin Bottom (pt)</mat-label>
                    <input
                        name="marginBottom"
                        matInput
                        type="number"
                        #marginBottom="ngModel"
                        [ngModel]="$item()?.pdfStyleSettings?.marginBottom"
                        (blur)="updatePdfStyleSettings('marginBottom', marginBottom.value)"
                        placeholder="0"
                    />
                </mat-form-field>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>Headline Font Size (pt)</mat-label>
                    <input
                        name="headlineFontSize"
                        matInput
                        type="number"
                        #headlineFontSize="ngModel"
                        [ngModel]="$item()?.pdfStyleSettings?.headlineFontSize"
                        (blur)="updatePdfStyleSettings('headlineFontSize', headlineFontSize.value)"
                        placeholder="40"
                    />
                </mat-form-field>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>Headline Char Spacing (pt)</mat-label>
                    <input
                        name="headlineCharSpacing"
                        matInput
                        type="number"
                        #headlineCharSpacing="ngModel"
                        [ngModel]="$item()?.pdfStyleSettings?.headlineCharSpacing"
                        (blur)="updatePdfStyleSettings('headlineCharSpacing', headlineCharSpacing.value)"
                        placeholder="4"
                    />
                </mat-form-field>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>Headline Font Weight</mat-label>
                    <mat-select [value]="$item()?.pdfStyleSettings?.headlineBold ?? false" (valueChange)="updatePdfStyleSettings('headlineBold', $event)">
                        <mat-option [value]="false">Regular</mat-option>
                        <mat-option [value]="true">Bold</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>Headline Padding (pt)</mat-label>
                    <input
                        matInput
                        type="number"
                        #headlinePadding="ngModel"
                        [ngModel]="$item()?.pdfStyleSettings?.headlinePadding"
                        (blur)="updatePdfStyleSettings('headlinePadding', headlinePadding.value)"
                        placeholder="20"
                    />
                </mat-form-field>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>Image Padding (pt)</mat-label>
                    <input
                        matInput
                        type="number"
                        #imagePadding="ngModel"
                        [ngModel]="$item()?.pdfStyleSettings?.imagePadding"
                        (blur)="updatePdfStyleSettings('imagePadding', imagePadding.value)"
                        placeholder="30"
                    />
                </mat-form-field>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>Table Header Font Size (pt)</mat-label>
                    <input
                        name="tableHeaderFontSize"
                        matInput
                        type="number"
                        #tableHeaderFontSize="ngModel"
                        [ngModel]="$item()?.pdfStyleSettings?.tableHeaderFontSize"
                        (blur)="updatePdfStyleSettings('tableHeaderFontSize', tableHeaderFontSize.value)"
                        placeholder="9"
                    />
                </mat-form-field>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>Table Font Size (pt)</mat-label>
                    <input
                        name="tableFontSize"
                        matInput
                        type="number"
                        #tableFontSize="ngModel"
                        [ngModel]="$item()?.pdfStyleSettings?.tableFontSize"
                        (blur)="updatePdfStyleSettings('tableFontSize', tableFontSize.value)"
                        placeholder="9"
                    />
                </mat-form-field>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>Table Line Height (multiplier)</mat-label>
                    <input
                        name="tableLineHeight"
                        matInput
                        type="number"
                        #tableLineHeight="ngModel"
                        [ngModel]="$item()?.pdfStyleSettings?.tableLineHeight"
                        (blur)="updatePdfStyleSettings('tableLineHeight', tableLineHeight.value)"
                        placeholder="1.8"
                    />
                </mat-form-field>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>Accent Color (hex)</mat-label>
                    <input
                        name="accentColor"
                        matInput
                        #accentColor="ngModel"
                        [ngModel]="$item()?.pdfStyleSettings?.accentColor"
                        (blur)="updatePdfStyleSettings('accentColor', accentColor.value)"
                        placeholder="#008C99"
                    />
                </mat-form-field>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>Text Color (hex)</mat-label>
                    <input
                        name="textColor"
                        matInput
                        #textColor="ngModel"
                        [ngModel]="$item()?.pdfStyleSettings?.textColor"
                        (blur)="updatePdfStyleSettings('textColor', textColor.value)"
                        placeholder="#414042"
                    />
                </mat-form-field>

                <h4>Metrics</h4>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>Materials</mat-label>
                    <input name="materialsCount" [disabled]="true" matInput [ngModel]="$item()?.materialsCount" />
                </mat-form-field>
                <mat-form-field [cmIsLoading]="!$item()">
                    <mat-label>Models</mat-label>
                    <input name="modelsCount" [disabled]="true" matInput [ngModel]="$item()?.modelsCount" />
                </mat-form-field>
            </ng-container>
        </cm-details-dialog-layout>
    </ng-container>
</cm-routed-dialog>
